
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src2723206075/src/vl-app/pages/patients/session.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from '@hooks/useRouter';
import dynamic from '@components/utils/lazy-loader';
import { Alert, AlertProps, Button } from 'antd';
import * as actions from '@actions';
import * as actionTypes from '@actionTypes';
import { css } from '@emotion/react';
import ProfileImage from 'vl-common/src/components/UI/ProfileImage/ProfileImage';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import { ThemeProvider } from 'styled-components';
import { lightTheme, MeetingProvider } from 'amazon-chime-sdk-component-library-react';
import { useDispatch } from 'react-redux';
import useCallStatus from '@hooks/useCallStatus';
import useAppointmentDelays from '@hooks/useAppointmentDelays';
import useAppointmentCountdown from '@hooks/useAppointmentCountdown';
import useCancelledNotification from '@hooks/useCancelledNotification';
import { getAppointmentStati } from '@helper';
import { useTwilioWS } from '@hooks/twilioWS';
import { useRoom } from '@hooks/useRoom';
import useMediaQuery from 'vl-common/src/hooks/useMediaQuery';
import Datestamp from 'vl-common/src/components/Datestamp';
import PermissionsCheckWarning from '@components/PermissionsCheck/PermissionsCheckWarning';
import VideoContainer from '@components/Video/VideoContainer';
import useConfluenceArticle from '@hooks/useConfluenceArticle';
import { FaStethoscope } from 'react-icons/fa';
import useClinicianChanged from '@hooks/useClinicianChanged';
import { SimpleVideo } from '@components/Video/SimpleVideo';
import volumeSvg from '@svg/volume.svg';
import styled from '@emotion/styled';
import { errorModal, InfoModal, infoModal } from 'vl-common/src/components/Modals';
import { useRuntimeConfig } from 'vl-core/useRuntimeConfig';
import { stopLocalParticipant, useStopTwilioOnUnmount } from '@hooks/useStopTwilioOnUnmount';
import { useMutation } from '@tanstack/react-query';
import MediaPermissionsWarning from '@components/MediaPermissions/MediaPermissionsWarning';
import useSendTwilioEvents from '@hooks/useSendTwilioEvents';
import AppointmentEndNotification from '@components/AppointmentEndNotification/AppointmentEndNotification';
import Header from '@components/Layouts/Header/Header';
import { CallTestProvider } from '@lib/context/CallTest';
import ContentLoader from '@components/UI/ContentLoader';

const CallTest = dynamic(() => import('@components/Patients/CallTest'), {
  loading: () => <ContentLoader minHeight="60vh" />
});

const StyledPatientSessionPage = styled.div`
  .clinician-calling-modal .ant-modal .ant-modal-body {
    padding: 15px;
  }

  .aws_container {
    min-height: 200px;
    background: white;
    box-shadow: 0 3px 6px #0000004d;
    border-radius: 10px;
    text-align: center;
    position: relative;
    padding: 16px;
    min-width: 50%;
  }

  .item-icon {
    display: block;
    margin-top: 24px;
    margin-left: 24px;
    width: 100px;
    height: 100px;
  }

  .patient-session {
    font-family: Montserrat;

    .session-head {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid var(--productGray);
      padding-bottom: 5px;

      .head-back {
        font: Bold 30px/33px Montserrat;
        color: var(--black);
      }
    }

    .session-content {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px 0;
      color: var(--productGray);

      .doctor-image {
        width: 150px;
        border-radius: 50%;
        overflow: hidden;
        height: 150px;
        box-shadow: 0 3px 6px #00000029;

        > img {
          object-fit: cover;
          width: 150px;
          height: 150px;
        }
      }

      .doctor-name {
        margin: 0 0 20px;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
      }

      .session-time {
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        margin-top: 2rem;

        > p {
          margin: 20px 0;
          font-size: 30px;
          font-weight: 700;
        }
      }

      .session-status {
        margin: 20px 0 0 0;
        font-weight: 500;
      }
    }

    .session-call {
      video {
        width: 100%;
      }
      .tabs-callee {
        position: relative;
        padding: 1rem;
        top: 0;
        left: 0;
      }
      .tabs-caller {
        position: absolute;
        bottom: 1rem;
        z-index: 3;
        right: 1rem;
        .participant {
          width: 35%;
          display: inline-block;
          float: right;
        }
      }
    }
    .call-button {
      width: auto;
      position: absolute;
      top: 70%;
      padding: 10px 50px !important;

      &.left {
        left: -15%;
      }

      &.right {
        right: -15%;
      }
    }

    .tabs-audio-card-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 450px;
      height: 600px;
      text-align: center;
      background: #dbdddf 0 0 no-repeat padding-box;
      box-shadow: 0 3px 6px #0000004d;
      margin-top: 40px;

      .tabs-audio-card-text {
        font: 28px/32px Montserrat;
        font-weight: 500;
        display: inline-block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }

      .tabs-audio-icon {
        position: relative;
        margin-right: 5px;
        width: 36px;
      }
    }
  }

  .waiting-room-article {
    max-width: 1024px;
    width: 100%;
    text-align: left;
    margin: 0 auto;
    padding: 10px 20px;

    img {
      width: 50%;
    }

    h1,
    h2 {
      margin-top: 20px;
    }

    .columnLayout {
      display: table;
      table-layout: fixed;
      width: 100%;
      clear: both;
    }

    .cell {
      display: table-cell;
      padding: 0 10px;
    }

    content .cell {
      margin: 8px 0;
      box-sizing: border-box;
      word-wrap: break-word;
      -moz-border-radius: 5px;
      -webkit-border-radius: 5px;
      border-radius: 5px;
    }

    .contentLayout2 .columnLayout .cell {
      padding-left: 15px;
      padding-right: 15px;
    }

    .columnLayout .cell {
      vertical-align: top;
    }

    details summary {
      cursor: pointer;
    }

    summary {
      outline: none;
    }

    details {
      border-bottom: solid 1px;
      padding: 20px 0;

      p {
        margin: 0;
      }
    }

    .expand-control-text {
      vertical-align: top;
      font-weight: 600;
    }

    .expand-content {
      margin: 10px 10px 0 20px;
    }
  }
`;

const RenderTime = ({ counter }: { counter: number }) => {
  const { t } = useTranslation('common');
  const minutes = Math.floor(counter / 60);
  const seconds = counter % 60;
  const DoubleDigit = ({ n }) => <>{String(n).padStart(2, '0')}</>;

  if (minutes <= 0) return <span className="cs-appointment-time">{t('now')}</span>;

  return (
    <span className="cs-appointment-time">
      {t('in ')}
      <DoubleDigit n={minutes} />:<DoubleDigit n={seconds} />
    </span>
  );
};

const PatientsSession = ({ appointment, sessionType, setClinicianChanged }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { PVIDEO } = useRuntimeConfig();
  type PageState = 'waiting' | 'testing' | 'in-session';
  const [pageState, setPageState] = useState<PageState>('waiting');
  const [videoCallCompleted, setVideoCallCompleted] = useState(false);
  const [videoStarted, setVideoStarted] = useState(false);
  const { delayInMinutes } = useAppointmentDelays(appointment);
  const counter = useAppointmentCountdown(appointment, { delayInMinutes });
  const callStatus = useCallStatus(appointment);
  const [cancelled] = useCancelledNotification(appointment);
  const router = useRouter();
  const [alert, setAlert] = useState<null | { type: string; message: string }>(null);
  const isWideDisplay = useMediaQuery('(min-width: 500px)');
  const article = useConfluenceArticle('CONF_WAITING_ROOM');
  const [secondaryToken, setSecondaryToken] = useState('');
  const [canRejoinSession, setCanRejoinSession] = useState(false);
  const { roomName, token, sendTokenRequest, open, sendControlMessage, close } = useTwilioWS(appointment, {
    onTokenReceived: (token) => setSecondaryToken(token)
  });
  const { room, error: connectionError } = useRoom(roomName, (sessionType === 'VIDEO' && token) || '', appointment);
  const sendTwilioEvents = useSendTwilioEvents();

  useStopTwilioOnUnmount(room);

  useEffect(() => {
    if (connectionError) {
      setAlert({
        type: 'error',
        message: `Could not connect to video provider, please refresh window to continue: ${connectionError?.toString()}`
      });
    } else {
      setAlert(null);
    }
  }, [connectionError]);

  const [newClinicianName, setNewClinicianName] = useClinicianChanged(appointment);

  useEffect(() => {
    if (newClinicianName) {
      infoModal({
        title: 'Clinician Changed',
        content: `${newClinicianName} has now been assigned to your appointment`,
        onOk: () => {
          setClinicianChanged(newClinicianName);
          setNewClinicianName(null);
        }
      });
    }
  }, [newClinicianName]);

  useEffect(() => {
    getAppointmentStati({ dispatch, actions, appointment_id: appointment?.appointment_id })?.then((canRejoin) => {
      if (canRejoin) {
        setCanRejoinSession(true);
        setVideoStarted(true);
      }
    });
  }, [appointment]);

  useEffect(() => {
    setVideoStarted(callStatus === 'in-progress' || canRejoinSession);
  }, [callStatus]);

  function TimeRemaining() {
    if (pageState === 'waiting') {
      if (cancelled) {
        return <>{t('Cancelled')}</>;
      }

      return (
        <>
          {t('Due to start ')}
          <RenderTime counter={counter} />
          <span>{delayInMinutes ? ` ( Appointment delayed by ${delayInMinutes} minutes ) ` : ''}</span>
        </>
      );
    }

    return (
      <Datestamp
        date={appointment.datetime}
        format={
          isWideDisplay
            ? 'Date @ Time (long, 24h) - Friday, March 3rd, 2022 @ 08:57'
            : 'Date @ Time (short, no year, 24h) - Fri, Mar 3rd @ 08:57'
        }
      />
    );
  }

  useEffect(() => {
    sendControlMessage({ partyStatus: 'in-session', iam: 'patient' });

    return () => sendControlMessage({ partyStatus: 'connected', iam: 'patient' });
  }, [sendControlMessage]);

  useEffect(() => {
    if (videoStarted) setPageState('in-session');
  }, [videoStarted]);

  useEffect(() => {
    if (callStatus === 'completed') {
      setVideoCallCompleted(true);
      close();
    }
  }, [callStatus, close]);

  useEffect(() => {
    if (callStatus === 'completed' && room) stopLocalParticipant(room.localParticipant);
  }, [callStatus, room]);

  const closeModalAndStopRecording = async (surveyId?: number) => {
    setVideoCallCompleted(false);
    if (surveyId) {
      router.replace(`/patients/assessments?surveyjs_id=${surveyId}`);
    } else {
      router.replace('/patients').then();
    }
  };

  const { mutate: postPremsRequest, isPending } = useMutation({
    mutationFn: async (showPrems: boolean) => {
      const res = await dispatch(
        actions.postPremsRequest(appointment?.appointment_id, showPrems, appointment?.patient_user_guid)
      );

      return res;
    },
    onSuccess: (res) => {
      if (res.survey_id) {
        closeModalAndStopRecording(res.survey_id);
      } else if (res.prems_requested) {
        errorModal({
          title: 'No PREMS Survey Available',
          content: 'There is no PREMS survey available for this appointment.',
          onOk: () => closeModalAndStopRecording()
        });
      } else {
        closeModalAndStopRecording();
      }
    },
    onError: (error) => {
      closeModalAndStopRecording();
    }
  });

  const startTesting = () => {
    setPageState('testing');
  };

  const closeTesting = () => {
    setPageState('waiting');
  };

  return (
    <StyledPatientSessionPage className="page-container">
      <Header pageType="patients" pageTitle="Session" />

      <section className="section-layout patient-session patient">
        <main className="container" id="page-content">
          <h1>
            {t('Appointment with')} {appointment.clinician}
          </h1>
          <div className="session-head">
            <div className="head-back">
              <span className="session-date">
                <TimeRemaining />
              </span>
            </div>
          </div>

          <div className="session-content">
            {alert && (
              <Alert
                css={css({ marginBottom: '1rem' })}
                message={alert.message}
                type={alert.type as AlertProps['type']}
                closable
                afterClose={() => setAlert(null)}
                showIcon
              />
            )}
            <CallTestProvider>
              <ThemeProvider theme={lightTheme}>
                <MeetingProvider>
                  <>
                    {PVIDEO === 'twilio' && (
                      <>
                        {pageState === 'waiting' && (
                          <>
                            <PermissionsCheckWarning showWithoutAppointment isWaitingRoom startTesting={startTesting} />
                            <h2 className="doctor-name">
                              {appointment.clinician}'s
                              <br />
                              {t('Waiting room')}
                            </h2>

                            <span className="doctor-image">
                              {appointment?.clinician_avatar_url !== null ? (
                                <ProfileImage
                                  user={appointment?.clinician_user_guid}
                                  width="100%"
                                  alt={appointment?.clinician}
                                />
                              ) : (
                                <FaStethoscope className="item-icon" />
                              )}
                            </span>

                            <div className="waiting-room-article" dangerouslySetInnerHTML={{ __html: article }} />

                            <Button
                              style={{ marginTop: '1.5rem', marginBottom: '20px' }}
                              onClick={() => {
                                startTesting();
                                sendTwilioEvents({
                                  userGuid: appointment.patient_user_guid,
                                  appointmentId: appointment.appointment_id,
                                  event: 'PATIENT_TEST_CALL'
                                });
                              }}
                              data-testid="test-webcam"
                            >
                              {t('Test WebCam')}
                            </Button>
                          </>
                        )}
                        {pageState === 'testing' && (
                          <CallTest appointment={appointment} closeHandler={closeTesting} PVIDEO={PVIDEO} />
                        )}
                        {pageState === 'in-session' && (
                          <>
                            <MediaPermissionsWarning
                              isInCallingWindow={true}
                              storageKey={`patient-session-${appointment?.appointment_id}`}
                              callType={sessionType}
                              style={{ width: '100%', marginBottom: '20px' }}
                            />
                            {sessionType === 'AUDIO' && (
                              <div className="tabs-audio-card-content">
                                <span className="tabs-audio-card-text">
                                  <img className="tabs-audio-icon" alt={t('Volume icon')} src={volumeSvg} />{' '}
                                  {t('Audio Call')}
                                </span>
                              </div>
                            )}
                            {sessionType !== 'AUDIO' && callStatus !== 'completed' && (
                              <>
                                <AppointmentEndNotification appointment={appointment} />
                                <SimpleVideo
                                  appointment={appointment}
                                  room={room}
                                  secondaryToken={secondaryToken}
                                  sendTokenRequest={sendTokenRequest}
                                  open={open}
                                  roomName={roomName}
                                  isTestCall={!videoStarted}
                                />
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                    {PVIDEO === 'chime' && (
                      <>
                        {sessionType === 'VIDEO' && pageState === 'waiting' && (
                          <>
                            <h2 className="doctor-name">
                              {appointment.clinician}'s
                              <br />
                              {t('Waiting room')}
                            </h2>

                            <span className="doctor-image">
                              {appointment?.clinician_avatar_url !== null ? (
                                <ProfileImage
                                  user={appointment?.clinician_user_guid}
                                  width="100%"
                                  alt={appointment?.clinician}
                                />
                              ) : (
                                <FaStethoscope className="item-icon" />
                              )}
                            </span>

                            <div className="waiting-room-article" dangerouslySetInnerHTML={{ __html: article }} />

                            <Button
                              style={{ marginTop: '1.5rem' }}
                              onClick={() => {
                                startTesting();
                                sendTwilioEvents({
                                  userGuid: appointment.patient_user_guid,
                                  appointmentId: appointment.appointment_id,
                                  event: 'PATIENT_TEST_CALL'
                                });
                              }}
                              data-testid="test-webcam"
                            >
                              {t('Test WebCam')}
                            </Button>
                          </>
                        )}
                        {sessionType === 'VIDEO' && callStatus === 'in-progress' && (
                          <>
                            <MediaPermissionsWarning
                              isInCallingWindow={true}
                              storageKey={`patient-session-${appointment?.appointment_id}`}
                              callType={sessionType}
                              style={{ width: '100%', marginBottom: '20px' }}
                            />
                            <div className="aws_container">
                              <VideoContainer
                                token={token}
                                clinician_guid={appointment?.clinician_user_guid}
                                patient_guid={appointment?.patient_user_guid}
                                callStatus={callStatus}
                                sendTokenRequest={sendTokenRequest}
                                open={open}
                                appointment={appointment}
                              />
                            </div>
                          </>
                        )}
                        {pageState === 'testing' && (
                          <CallTest
                            appointment={appointment}
                            closeHandler={closeTesting}
                            sendTokenRequest={sendTokenRequest}
                            token={token}
                            PVIDEO={PVIDEO}
                            clinician_guid={appointment?.clinician_user_guid}
                            patient_guid={appointment?.patient_user_guid}
                            isClinician={false}
                          />
                        )}
                      </>
                    )}
                  </>
                </MeetingProvider>
              </ThemeProvider>
            </CallTestProvider>
          </div>
        </main>
      </section>

      <InfoModal
        open={videoCallCompleted}
        title="Appointment completed"
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ 'data-testid': 'stop' }}
        footer={[
          <p key="text" style={{ textAlign: 'left' }}>
            {t('Would you like to provide feedback?')}
          </p>,
          <Button data-testid="no-prems" key="cancel" onClick={() => postPremsRequest(false)} loading={isPending}>
            {t('No')}
          </Button>,
          <Button
            data-testid="route-to-prems"
            key="prems"
            type="primary"
            onClick={() => postPremsRequest(true)}
            loading={isPending}
          >
            {t('Yes')}
          </Button>
        ]}
      >
        {t('Your clinician will now write-up the appointment notes.')}
      </InfoModal>
    </StyledPatientSessionPage>
  );
};

const PatientsSessionWrapper = () => {
  const { t } = useTranslation('common');
  const initialised = useInitialisedStore();
  const router = useRouter();
  const {
    query: { req, on }
  } = router;
  const [appointment, setAppointment] = useState(null);
  const [clinicianChanged, setClinicianChanged] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (initialised) {
      const querydecrypt = Buffer.from(`${req}`, 'base64').toString();
      const request: any = req ? { appt_id: querydecrypt } : {};

      if (on) {
        request.status = 'pending';
      }

      dispatch(actions.getUserAppointment('USER_APPOINTMENTS', request))
        .then((response) => {
          if (response.type === actionTypes.USER_APPOINTMENTS_FAIL) {
            router.push('/patients').then();
          } else {
            const appointment = response?.payload?.[0];

            if (!appointment && response.type === actionTypes.USER_APPOINTMENTS_SUCCESS) {
              // appointment is probably cancelled
              router.push('/patients').then();
            }

            setAppointment(appointment);
          }
        })
        .then();
    }
  }, [initialised, req, on, dispatch, router, clinicianChanged]);

  if (!initialised || !appointment) {
    return <p>{t('Initialising ...')}</p>;
  }

  return <PatientsSession appointment={appointment} sessionType={on} setClinicianChanged={setClinicianChanged} />;
};


export const Route = createFileRoute('/patients/session')({ component: PatientsSessionWrapper });
